import 'dayjs/locale/sk'
import { Dayjs } from 'dayjs'

const sk = {
  calendar: {
    sameDay: '[dnes o] LT',
    nextDay: '[zajtra o] LT',
    nextWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[v nedeľu o] LT')
        case 1:
        case 2:
          return now.format('[v] dddd [o] LT')
        case 3:
          return now.format('[v stredu o] LT')
        case 4:
          return now.format('[vo štvrtok o] LT')
        case 5:
          return now.format('[v piatok o] LT')
        case 6:
          return now.format('[v sobotu o] LT')
      }
    },
    lastDay: '[včera o] LT',
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[minulú nedeľu o] LT')
        case 1:
        case 2:
          return now.format('[minulý] dddd [o] LT')
        case 3:
          return now.format('[minulú stredu o] LT')
        case 4:
        case 5:
          return now.format('[minulý] dddd [o] LT')
        case 6:
          return now.format('[minulú sobotu o] LT')
      }
    },
    sameElse: 'L'
  }
}

export default sk
